'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownLanguageMenu = void 0;
const $ = require("jquery");
class DropdownLanguageMenu {
    constructor() {
        // $('.bulletDropdownLanguageMenu').slideUp();
        $('.trigDropdownLanguageMenu').on('mouseover', (e) => {
            // $(e.currentTarget).attr('data-is-open', 'true');
            $('.bulletDropdownLanguageMenu').stop().slideDown();
            $('.paramChangeArrow').attr('data-is-open', 'true');
        });
        $('.trigDropdownLanguageMenu').on('mouseout', (e) => {
            // $(e.currentTarget).attr('data-is-open', 'false');
            $('.bulletDropdownLanguageMenu').stop().slideUp();
            $('.paramChangeArrow').attr('data-is-open', 'false');
        });
    }
}
exports.DropdownLanguageMenu = DropdownLanguageMenu;
exports.default = DropdownLanguageMenu;
